import Honeybadger from '@honeybadger-io/js'
import { httpGet } from './http'
import { ServiceError } from './errors'
import { HTTPStatus } from '~/api/httpStatus'
import type { IOverviewLastSelectedState } from '~/types/overview/models'

export function makeGetRouteForLastSelectedTab<
  E extends IOverviewLastSelectedState
>(
  apiEntityPath: string,
  overviewName: string,
  defaultTabName: string = 'Sales'
) {
  async function getRouteForLastSelectedTab(id: string) {
    const callingMn = getRouteForLastSelectedTab.name
    const fn = `[services/factories.ts] ${callingMn} |`
    const apiPath = `${apiEntityPath}/${id}/lastselectedstate`
    let tab = `${defaultTabName}`
    try {
      const data = await httpGet<E>({
        callingMn,
        apiPath,
      })
      tab = data?.selectedScreenTopTabValue ?? tab
    } catch (error) {
      // A 403 has already logged the user out and sent them to Login (httpGet
      // runs handleAsyncDataErrors for it); navigating on would race that.
      if (
        error instanceof ServiceError &&
        error.statusCode === HTTPStatus.Forbidden
      ) {
        throw error
      }
      // Anything else: open the DEFAULT tab rather than nothing. This lookup
      // only picks which tab to open; failing it made a list-row click
      // silently do nothing (Honeybadger 135002008, a 503 while the API was
      // deploying). If the API really is down, the overview's own load fails
      // next, and that failure is shown to the user.
      console.error(`${fn} lookup failed, opening '${tab}' -`, error)
      Honeybadger.notify(error as Error, {
        name: 'LastSelectedTabLookupFailed',
        context: { apiPath, defaultTab: tab },
      })
    }
    console.debug(`getRouteForLastSelectedTab`, tab)
    return `${overviewName}-${tab}-id`
  }
  return getRouteForLastSelectedTab
}
